<template>
  <div>
    <div class="edit_main">
      <el-form size="mini">
        <el-form-item label="推广平台：">
          <el-radio-group v-model="advertiser.params.type" size="mini" @change="platformChange">
            <el-radio-button v-for="key in channel_interface" :key="key" :label="key">{{ channel_interface_map[key] }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="广告主列表：">
          <el-button plain size="mini" icon="el-icon-plus" @click="showBatchBox">批量增加</el-button>
          <div v-loading="!advertiser.response[advertiser.params.type].length" class="chose_box">
            <div v-for="key in channel_interface" :key="key">
              <tree-shuttle
                v-if="advertiser.response[key].length && tree_show"
                v-model="platform[key]"
                v-loading="advertiser.loading"
                :title="`${channel_interface_map[key]}广告主`"
                :init-data="advertiser.response[key]"
                :filter-node-method="filterAdvertiser"
              />
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span class="footer">
      <el-button size="mini" @click="editCancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="editConfirm">确 定</el-button>
    </span>

    <!-- 批量添加广告主 -->
    <el-dialog
      title="批量添加广告主"
      :visible.sync="batch_box_show"
      width="45%"
      :before-close="closeBatchBox"
      append-to-body
    >
      <bacth-add v-if="batch_box_show" @cancel="closeBatchBox" @config="configBatch" />
    </el-dialog>
  </div>
</template>

<script>
import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();
import TreeShuttle from '@/components/tree-shuttle';
import { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } from '@/enums';
import { transformEnumToObject } from '@/tools';

export default {
  components: {
    'tree-shuttle': TreeShuttle,
    'bacth-add': () => import('./bacth_add'),
  },
  props: {
    // 编辑参数
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tree_show: true,
      batch_box_show: false,
      advertiser: {
        loading: false,
        response: {},
        params: {
          type: CHANNEL_INTERFACE_TYPE.JRTT,
          is_list: true,
          allot: 1,
        },
      },
      edit: {
        init: { name: '' },
        params: {
          id: '',
        },
      },
      platform: {},
      channel_interface: Object.values(CHANNEL_INTERFACE_TYPE).filter(value => value !== CHANNEL_INTERFACE_TYPE.JRTT_V3),
      channel_interface_map: transformEnumToObject(CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT),
    };
  },
  created() {
    this.initData();
    this.edit.params.id = this.data.id;
    // 先分类
    this.classificationFormPlatform(this.data.advertisers);
    this.getMediasList();
  },
  methods: {
    /**
     * 初始化data数据
     * @returns {void}
     */
    initData() {
      this.channel_interface.forEach(key => {
        this.$set(this.advertiser.response, key, []);
        this.$set(this.advertiser.response, `${key}_data`, []);
        this.$set(this.platform, key, []);
      });
    },
    // 根据平台获取广告主
    platformChange() {
      this.channel_interface.forEach(key => {
        this.advertiser.response[key] = [];
      });
      this.getMediasList();
    },

    // 完成批量添加广告主
    configBatch(list){
      const _list = [...new Set(list)].filter(item => {
        return item;
      });
      let init_data = [];
      const { type } = this.advertiser.params;
      if (this.isMediaPlatform(type)) {
        init_data = this.advertiser.response[`${type}_data`];
        this.platform[type].push(...this.filterIds(init_data, _list));
        this.platform[type] = [...new Set(this.platform[type])];
      }
      this.closeBatchBox();
      this.updataTree();
    },

    // 通过广告主id 查找资源id
    filterIds(init_data, list){
      return init_data.filter(item => {
        let flag = false;
        list.forEach(e => {
          item.advertiser_id === e || item.advertiser_name === e ? flag = true : '';
        });
        return flag;
      }).map(item => {
        return item.id;
      });
    },

    // 显示批量盒子
    showBatchBox(){
      this.batch_box_show = true;
    },

    // 关闭批量盒子
    closeBatchBox(){
      this.batch_box_show = false;
    },

    // 刷新组件
    updataTree(){
      this.tree_show = false;
      this.$nextTick(() => {
        this.tree_show = true;
      });
    },

    // 根据平台分类
    classificationFormPlatform(list) {
      Object.keys(this.platform).forEach(key => {
        this.platform[key].splice(0);
      });
      list.forEach(({ type, id }) => {
        if (this.isMediaPlatform(type)) {
          this.platform[type].push(id);
        }
      });
    },

    // 获取广告主
    async getMediasList() {
      this.advertiser.loading = true;
      await mediasResource
        .getMediasListApi(this.advertiser.params)
        .then(response => {
          this.advertiser.response[`${this.advertiser.params.type}_data`] = response.list;
          this.advertiser.response[
            this.advertiser.params.type
          ] = this.resetAdvertiserList(response.list);
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.advertiser.loading = false;
        });
    },

    // 重置广告主列表
    resetAdvertiserList(list) {
      return list.map((item, index) => {
        const _list = {
          id: item.id,
          advertiser_id: item.advertiser_id,
          label: item.advertiser_name,
        };
        return _list;
      });
    },

    // 广告主名称支持模糊匹配，广告主ID仅支持精确匹配
    filterAdvertiser(value, data) {
      if (!value) {
        return true;
      }
      const keyword = String(value);
      const label = data.label == null ? '' : String(data.label);
      const advertiserId = data.advertiser_id == null ? '' : String(data.advertiser_id);
      return label.indexOf(keyword) !== -1 || advertiserId === keyword;
    },

    // 确认编辑
    editConfirm() {
      const { id } = this.edit.params;
      const params = {
        uid: id,
        ids: this.getAllIds(),
      };
      mediasResource
        .assignAdvertiserApi(params)
        .then(response => {
          this.$message.success('修改绑定广告主成功');
          this.$emit('config');
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取所有媒体平台广告主ID
    getAllIds() {
      const ids = [];
      Object.entries(this.platform).forEach(([, value]) => {
        ids.push(...value);
      });
      return ids;
    },

    editCancel() {
      this.$emit('cancel');
    },

    // 是否是媒体平台
    isMediaPlatform(type) {
      return this.channel_interface.includes(type);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-input,
.el-select {
  width: 350px !important;
}
.chose_box{
  margin-left: 95px;
  margin-top: 10px;
}
.footer {
  display: block;
  text-align: center;
}
</style>
